import { ExamLocationDetailsProvider } from '@exam-center/exam-center-location-details';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { useParams } from '@exam-center/router';
import { PermissionGuard } from '@shared/permissions';
import { Outlet } from 'react-router-dom';

export default function ExamLocationLayout() {
  const { examCenterCode, roomId } = useParams('/:examCenterCode/exam-location/locations/:roomId');

  return (
    <PermissionGuard
      requiredPermission={APP_PERMISSIONS.EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION.VIEW}
    >
      <ExamLocationDetailsProvider roomId={roomId} examCenterCode={examCenterCode}>
        <Outlet />
      </ExamLocationDetailsProvider>
    </PermissionGuard>
  );
}
